import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import "./App.css";

// ─── KONFIGURATION ──────────────────────────────────────────────────────────
const RELATION_TYPES = [
  "Situationship 🙃", "Bester Bro 🍺", "Green Flag ✅", "Red Flag 🚩", 
  "Ghosted 👻", "Delusional Phase ✨", "Wifey Material 💍", "Just for Fun 💃",
  "Secret Crush 🤫", "Ex-Back Mission 🔄", "F*ckboy Alert ⚠️"
];

const STATUS_CONFIG = {
  watching: { label: "👁️ Watching", color: "#FBBF24" },
  texting:  { label: "💬 Texting",  color: "#34D399" },
  dating:   { label: "🔥 Dating",   color: "#F87171" },
  fading:   { label: "🌫️ Fading",   color: "#9CA3AF" },
};

const EMOJIS = ["🫦", "😎", "🤡", "🚩", "💅", "🎭", "🧸", "🔥", "🧊", "🦄", "🍕", "🥂"];

function getCrushColor(id) {
  const colors = ["#6366F1", "#EC4899", "#8B5CF6", "#10B981", "#F59E0B", "#EF4444"];
  const index = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return colors[index % colors.length];
}

export default function App() {
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [crushes, setCrushes] = useState([]);
  const [expandedBoards, setExpandedBoards] = useState({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingCrush, setEditingCrush] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function init() {
      const { data: c } = await supabase.from("crushes").select("*").order("since_date", { ascending: false });
      const { data: u } = await supabase.from("users").select("name");
      setCrushes(c || []);
      setUsers(u?.map(r => r.name) || []);
      setLoading(false);
    }
    init();
  }, []);

  const toggleBoard = (name) => {
    setExpandedBoards(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleArchive = async (id, shouldArchive) => {
    const update = { archived: shouldArchive, archived_at: shouldArchive ? new Date().toISOString() : null };
    setCrushes(prev => prev.map(c => c.id === id ? { ...c, ...update } : c));
    await supabase.from("crushes").update(update).eq("id", id);
  };

  const handleSaveCrush = async (formData) => {
    if (editingCrush) {
      // Update
      setCrushes(prev => prev.map(c => c.id === editingCrush.id ? { ...c, ...formData } : c));
      await supabase.from("crushes").update(formData).eq("id", editingCrush.id);
      setEditingCrush(null);
    } else {
      // Neu
      const newEntry = { 
        ...formData, 
        id: Math.random().toString(36).substr(2, 9), 
        owner: user, 
        archived: false,
        created_at: new Date().toISOString()
      };
      setCrushes(prev => [newEntry, ...prev]);
      setShowAddModal(false);
      await supabase.from("crushes").insert([newEntry]);
    }
  };

  if (loading) return <div className="app-container">Watchboards werden poliert... ✨</div>;
  if (!user) return <Login onLogin={(n) => { setUser(n); if(!users.includes(n)) setUsers([...users, n]); }} knownUsers={users} />;

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>👁️ Watchlist</h1>
        <p>Eingeloggt als: <b>{user}</b> 💅</p>
      </header>

      {users.map(u => {
        const userCrushes = crushes.filter(c => c.owner === u);
        const activeCount = userCrushes.filter(c => !c.archived).length;

        return (
          <div key={u} className="board-card">
            <div className="board-header" onClick={() => toggleBoard(u)}>
              <div className="board-title">
                <span className="chevron">{expandedBoards[u] ? '▼' : '▶'}</span>
                {u}'s Watchboard
              </div>
              <div className="board-badge">{activeCount} Boys</div>
            </div>

            {expandedBoards[u] && (
              <div className="board-content">
                {u === user && (
                  <button className="btn-add-main" onClick={() => setShowAddModal(true)}>
                    + Neuen Typ hinzufügen
                  </button>
                )}
                
                <div className="crush-list">
                  {userCrushes.length === 0 ? <p className="empty-msg">Noch keine Spottings...</p> : 
                    userCrushes.map(c => (
                    <div key={c.id} className={`crush-row ${c.archived ? 'is-archived' : ''}`}>
                      <div className="crush-avatar">
                        {c.photo ? <img src={c.photo} alt="" className="avatar-img" /> : (c.emoji || '👤')}
                      </div>
                      <div className="crush-details">
                        <div className="crush-name-row">
                          <span className="crush-name">{c.name}</span>
                          <span className="relation-tag">{c.relation}</span>
                        </div>
                        <div className="crush-status">
                          {STATUS_CONFIG[c.status]?.label} • <small>{new Date(c.since_date).toLocaleDateString()}</small>
                        </div>
                      </div>
                      {u === user && (
                        <div className="action-group">
                          <button className="edit-btn" onClick={() => setEditingCrush(c)}>✏️</button>
                          <button className="archive-btn" onClick={() => handleArchive(c.id, !c.archived)}>
                            {c.archived ? '↩️' : '🗑️'}
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <div className="timeline-box">
                  <div className="timeline-label">LAST UPDATES</div>
                  {userCrushes.slice(0, 3).map(c => (
                    <div key={c.id + 't'} className="timeline-item">
                      <div className="timeline-dot" style={{backgroundColor: getCrushColor(c.id)}}></div>
                      <div className="timeline-text">
                        <b>{c.name}</b> ({new Date(c.since_date).toLocaleDateString()})
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}

      {(showAddModal || editingCrush) && (
        <CrushModal 
          initialData={editingCrush} 
          onSave={handleSaveCrush} 
          onClose={() => { setShowAddModal(false); setEditingCrush(null); }} 
        />
      )}
    </div>
  );
}

// ─── UNTER-KOMPONENTEN ──────────────────────────────────────────────────────

function Login({ onLogin, knownUsers }) {
  const [n, setN] = useState("");
  return (
    <div className="login-screen">
      <div className="login-card">
        <h2>Wer trackt heute mit? 🕵️‍♀️</h2>
        <input className="form-input" value={n} onChange={e => setN(e.target.value)} placeholder="Dein Name..." />
        <button className="btn-primary" onClick={() => n && onLogin(n)}>Board öffnen</button>
        {knownUsers.length > 0 && (
          <div className="known-users">
            <p>Schnell-Login:</p>
            {knownUsers.map(u => <button key={u} className="btn-user-tag" onClick={() => onLogin(u)}>{u}</button>)}
          </div>
        )}
      </div>
    </div>
  );
}

function CrushModal({ initialData, onSave, onClose }) {
  const [form, setForm] = useState(initialData || { 
    name: "", 
    status: "watching", 
    relation: "Situationship 🙃", 
    emoji: "🫦", 
    photo: "",
    since_date: new Date().toISOString().split('T')[0] 
  });

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h3>{initialData ? 'Eintrag bearbeiten ✏️' : 'Neues Objekt 🕵️‍♀️'}</h3>
        <div className="field">
          <label>Name</label>
          <input className="form-input" value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Spitzname..." />
        </div>
        <div className="field">
          <label>Profilfoto URL (optional)</label>
          <input className="form-input" value={form.photo} onChange={e => setForm({...form, photo: e.target.value})} placeholder="https://image-link.com/..." />
        </div>
        <div style={{display: 'flex', gap: '10px'}}>
          <div className="field" style={{flex: 1}}>
            <label>Vibe</label>
            <select className="form-select" value={form.relation} onChange={e => setForm({...form, relation: e.target.value})}>
              {RELATION_TYPES.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          <div className="field" style={{flex: 1}}>
            <label>Datum</label>
            <input type="date" className="form-input" value={form.since_date?.split('T')[0]} onChange={e => setForm({...form, since_date: e.target.value})} />
          </div>
        </div>
        <div className="field">
          <label>Emoji (falls kein Foto)</label>
          <div className="emoji-grid">
            {EMOJIS.map(em => (
              <button key={em} type="button" className={`emoji-btn ${form.emoji === em ? 'active' : ''}`} onClick={() => setForm({...form, emoji: em})}>{em}</button>
            ))}
          </div>
        </div>
        <div className="modal-actions-grid">
          <button className="btn-primary" onClick={() => onSave(form)}>Speichern</button>
          <button className="btn-secondary-large" onClick={onClose}>Abbrechen</button>
        </div>
      </div>
    </div>
  );
}